import { FavoriteBorderOutlined, SearchOutlined, ShoppingCartOutlined } from "@mui/icons-material";
import styled from "styled-components";
import { Link } from "react-router-dom"

const Info = styled.div`
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.2);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease;
    cursor: pointer;
`

const Container = styled.div`
    flex: 1;
    margin: 35px;
    min-width: 250px;
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5fbfd;
    position: relative;
    flex-direction: column;
    &:hover ${Info}{
        opacity: 1;
    }
`


const Circle = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: white;
    position: absolute;
`
const Image = styled.img`
    height: 75%;
    z-index: 0;
`
const Title = styled.h5`
    
`
const Icon = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    transition: all 0.5s ease;

    &:hover{
        background-color: #e9f5f5;
        transform: scale(1.1);
    }
`
const Product = ({item}) => {
  return (
    <Container>
        
        <Circle />
        <Image src={item.img} />
        <Info>
            {/* <Icon>
                <ShoppingCartOutlined />
            </Icon> */}
            <Icon>
                <Link to={`/product/${item._id}`}>
                    <SearchOutlined />
                </Link>
                
            </Icon>
            {/* <Icon>
                <FavoriteBorderOutlined />
            </Icon> */}
        </Info>
        <Title>{item.title}</Title>
        <Title>$ {item.price}</Title>
    </Container>
  )
}

export default Product
